<template>

  <div
    class="jumbotron p-5 m-0"
    style="background: url(https://quickin-media-production.s3.sa-east-1.amazonaws.com/SGd5gqgSW8QsvhEyxmKLIQrlsgEbJnZb5Nu2X9ToLct5IbA0cNdxzH2yKz6ihphZ/sl1223192635036.jpg); background-size: cover; color: white;">
    <div style="max-width: 600px; font-size: 1.2rem;">
      <h1 class="display-4">Seeker</h1>
      <p class="lead">O próximo nível do hunting</p>

      <p>O Seeker é uma funcionalidade beta, em fase de validação, criada para ajudar você a encontrar candidatos com muito mais precisão.</p>
      <p>Com uma busca inteligente e uma varredura profunda na internet, o Seeker vai além de palavras-chave para identificar profissionais com real aderência à vaga.</p>

      <h4 class="mb-3 mt-5">Como funciona</h4>
      <ul>
        <li>
          <h5>Prompt de busca</h5>
          <p>
            Você descreve o perfil ideal e a IA inicia a busca.
          </p>
        </li>
        <li>
          <h5>Validação em 5 dimensões</h5>
          <p>
            Cada candidato é analisado com base em critérios que ajudam a garantir mais compatibilidade.
          </p>
        </li>
        <li>
          <h5>Resultados mais qualificados</h5>
          <p>
            Você encontra talentos mais alinhados em menos tempo.
          </p>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
export default {
  name: 'JobSeekerJumbotron',
  components: {
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobSeeker/JobSeekerJumbotron.vue